import angular, { Injectable } from "angular";
import {
  GridConfigurationFactory,
  RecordGridViewService,
  vsServiceName,
} from "./service";

export const vsProviderName = `${vsServiceName}Provider`;

export class RecordGridViewServiceProvider implements angular.IServiceProvider {
  private readonly _configs: {
    [name: string]: Injectable<GridConfigurationFactory> | undefined;
  } = {};

  addGridConfiguration(
    name: string,
    config: Injectable<GridConfigurationFactory>
  ) {
    this._configs[name] = config;
  }

  $get: any = [
    "$injector",
    ($injector: angular.auto.IInjectorService) => {
      return new RecordGridViewService(this._configs, $injector);
    },
  ];
}
